export const DEMO_WRITE_BLOCKED_CODE = 'DEMO_WRITE_BLOCKED';

export const DEMO_WRITE_BLOCKED_MESSAGE =
  'Demo mode: this action is not permitted. Demo tenants can view forms and data but cannot add, edit, or delete.';

export const DEMO_WRITE_BLOCKED_EVENT = 'demo-write-blocked';

const DEMO_DASHBOARD_USER_TYPES = new Set([
  'client_admin',
  'employee',
  'city_admin',
]);

const WRITE_METHODS = new Set(['post', 'put', 'patch', 'delete']);

function dashboardUserType(): string | null {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const user = JSON.parse(raw) as { userType?: string };
    return user.userType || null;
  } catch {
    return null;
  }
}

export function isDemoTenantSession(): boolean {
  return localStorage.getItem('tenantIsDemo') === 'true';
}

/** True only for Client Admin / staff logged into a demo tenant. Super Admin is never blocked. */
export function isDemoDashboardWriteProtected(): boolean {
  const userType = dashboardUserType();
  if (!userType || userType === 'super_admin') return false;
  if (!DEMO_DASHBOARD_USER_TYPES.has(userType)) return false;
  return isDemoTenantSession();
}

export function isDemoWriteAllowlisted(url?: string): boolean {
  const path = String(url || '');
  if (/\/auth\/(login|otp|refresh|logout|demo)/i.test(path)) return true;
  if (/\/notifications\/web-push\/(subscribe|unsubscribe)/i.test(path)) return true;
  return false;
}

export function shouldBlockDemoApiWrite(method?: string, url?: string): boolean {
  if (!WRITE_METHODS.has(String(method || 'get').toLowerCase())) return false;
  if (!isDemoDashboardWriteProtected()) return false;
  if (isDemoWriteAllowlisted(url)) return false;
  return true;
}

export function notifyDemoWriteBlocked(message = DEMO_WRITE_BLOCKED_MESSAGE): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(DEMO_WRITE_BLOCKED_EVENT, { detail: { message } }));
}
